import { ChangeDetectionStrategy, Component } from "@angular/core";
import { LookerMemberManagementDashboardType } from "../../looker-member-management-dashboard-type.enum";
import { HideFilters } from "../../models/analytics-hide-filters.enum";

@Component({
  selector: "app-disenrollment-oversight-dashboard",
  templateUrl: "./disenrollment-oversight-dashboard.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DisenrollmentOversightDashboardComponent {
  filters: string[] = ["Projects"];
  dashboardType = LookerMemberManagementDashboardType.Disenrollment_Oversight_Dashboard;
  hideFilters: string[] = [HideFilters.PROJECT_ID, HideFilters.USER_ID, HideFilters.ORG_ID, HideFilters.CUSTOMER_NAME2];
}
